// extracted by mini-css-extract-plugin
export default {"iconWrapper":"iBiLPG"};